import type { Page } from '@subaio/utils'

import type { Container } from 'lib/container'
import type { UserAuth } from 'lib/store'

export const getContainer = (containers: Record<string, Container>, page: Page | null, userAuth: UserAuth) => {
	const name = page?.name ?? ''
	const container = containers[name] ?? containers.NotFound

	if (name === 'Flow' && userAuth.status === 'expired') return containers.NotAuthenticated

	switch (container.authentication.type) {
		case 'private':
			return userAuth.status === 'authenticated' ? container : containers.NotAuthenticated
		case 'public':
			return container
	}
}
